<template>
  <div id="bookAppointmentBtnGrp" class="flex justify-center items-center flex-col space-y-8">
    <a :href="'tel:' + phoneNo" target="_blank" v-if="phoneNo">
      <button type="button" class="border rounded-3xl p-3 w-fit flex items-center justify-center text-2xl bg-deep-green text-white font-mulish font-thin space-x-5" style="width: 33vw">
        <img src="@/assets/images/bookYourAppointment/phone.svg" style="width: 1.5vw" />
        <span>{{ phoneDisplayNo }}</span>
      </button>
    </a>

    <a :href="'https://wa.me/' + whatsappNo" target="_blank" v-if="whatsappNo">
      <button type="button" class="border rounded-3xl p-3 w-fit flex items-center justify-center text-2xl bg-deep-green text-white font-mulish font-thin space-x-5" style="width: 33vw">
        <img src="@/assets/images/bookYourAppointment/whatsapp.svg" style="width: 1.5vw" />
        <span>{{ whatsappDisplayNo }}</span>
      </button>
    </a>
  </div>
</template>

<script setup lang="ts">
import { useHeaderStore } from "@/stores/header";
import { useBookYourAppointmentStore } from "@/stores/bookYourAppointment";
import { computed, onMounted, ref, toRefs } from "vue";
import { useI18n } from "vue-i18n";

const headerStore = useHeaderStore();
const bookYourAppointmentStore = useBookYourAppointmentStore();
const { t, locale } = useI18n();

const props = defineProps({
  whatsappDisplayNo: {
    type: String,
  },
  whatsappNo: {
    type: String,
  },
  phoneDisplayNo: {
    type: String,
  },
  phoneNo: {
    type: String,
  },
});

onMounted(async () => {});

const goTo = (refName) => {};
</script>

<style scoped>
.el-input {
  width: 33.333333% !important;
}
.drop-down-group .group-name {
  color: #c4c4c4;
}
</style>